module.exports = __webpack_public_path__ + "img/city (11).aefd4e1e.png";